import { render, staticRenderFns } from "./RoyalShip.vue?vue&type=template&id=4b5d9c34&scoped=true"
import script from "./RoyalShip.vue?vue&type=script&lang=js"
export * from "./RoyalShip.vue?vue&type=script&lang=js"
import style0 from "./RoyalShip.vue?vue&type=style&index=0&id=4b5d9c34&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b5d9c34",
  null
  
)

export default component.exports